import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LandingPage from './pages/LandingPage';
import CompactView from './pages/CompactView';
import CernerShell from './shells/CernerShell';
import EcwShell from './shells/EcwShell';
import GenericShell from './shells/GenericShell';
import OpenEmrShell from './shells/OpenEmrShell';
import SmartLaunch from './pages/SmartLaunch';
import SmartCallback from './pages/SmartCallback';
import AuthGuard from './components/AuthGuard';
import { SessionProvider } from './context/SessionContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

const theme = (new URLSearchParams(window.location.search).get('theme') ?? 'cerner') as
  | 'cerner'
  | 'ecw'
  | 'generic'
  | 'openemr';

function RaapidApp() {
  return (
    <ErrorBoundary theme={theme}>
      <SessionProvider>
        <App />
      </SessionProvider>
    </ErrorBoundary>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <Routes>
        <Route path="/" element={<AuthGuard><LandingPage /></AuthGuard>} />
        <Route path="/cerner" element={<AuthGuard><CernerShell /></AuthGuard>} />
        <Route path="/ecw" element={<AuthGuard><EcwShell /></AuthGuard>} />
        <Route path="/generic" element={<AuthGuard><GenericShell /></AuthGuard>} />
        <Route path="/openemr" element={<AuthGuard><OpenEmrShell /></AuthGuard>} />
        <Route path="/launch" element={<SmartLaunch />} />
        <Route path="/callback" element={<SmartCallback />} />
        <Route path="/app" element={<AuthGuard><RaapidApp /></AuthGuard>} />
        <Route path="/compact" element={
          <AuthGuard>
            <ErrorBoundary theme={theme}>
              <SessionProvider>
                <CompactView />
              </SessionProvider>
            </ErrorBoundary>
          </AuthGuard>
        } />
        <Route path="*" element={<AuthGuard><LandingPage /></AuthGuard>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
